import React, { useRef } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import SortAscIcon from "@druva-apps/orion-icons/lib/SortascendingGreyOutline";
import SortDescIcon from "@druva-apps/orion-icons/lib/SortdescendingGreyOutline";
import SortAvailIcon from "@druva-apps/orion-icons/lib/SortavailableGreyOutline";

/**
 * default SortIndicator for BaseTable
 */
const SortIndicator = ({ sortOrder, className, style }) => {
  const sortRef = useRef(null);
  const cls = cn(
    "BaseTable__sort-indicator",
    "orion-data-grid__navigation--empty-button",
    className,
    {
      "BaseTable__sort-indicator--descending": sortOrder === "desc"
    }
  );

  return (
    <button
      aria-label="Sort"
      ref={sortRef}
      type="button"
      className={cls}
      style={{
        userSelect: "none",
        width: "20px",
        height: "20px",
        lineHeight: "20px",
        textAlign: "center",
        ...style
      }}
    >
      {sortRef.current &&
      sortRef.current.parentNode.classList.contains(
        "orion-data-grid__header-cell--sorting"
      ) ? (
        sortOrder === "desc" ? (
          <SortAscIcon inheritFontColor />
        ) : (
          <SortDescIcon inheritFontColor />
        )
      ) : (
        <SortAvailIcon inheritFontColor className="oui-ml-1" />
      )}
    </button>
  );
};

SortIndicator.propTypes = {
  sortOrder: PropTypes.oneOf(["asc", "desc"]),
  className: PropTypes.string,
  style: PropTypes.object
};

export default SortIndicator;
